import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { emptyQuizzes } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectPlayerSessionsResult,
  selectQuizReadyEpisodeData,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EmptyView } from '../EmptyView';

export const QuizReady = () => {
  const compliance = useSelector(selectUserCompliance);
  const { isSuccess: isPlayerSessionsSuccess } = useSelector(
    selectPlayerSessionsResult,
  );
  const episodeQuizData = useSelector(selectQuizReadyEpisodeData);
  const quizReadyEpisodeIds = Object.keys(episodeQuizData);

  const {
    data: episodes = [],
    isSuccess,
    isLoading,
  } = useFetchEpisodesQuery(
    {
      episodeIds: quizReadyEpisodeIds,
      compliance,
    },
    {
      skip: !quizReadyEpisodeIds?.length,
    },
  );

  const isEmpty =
    (isPlayerSessionsSuccess && !quizReadyEpisodeIds.length) ||
    (isSuccess && !episodes.length);

  return (
    <Box>
      {isEmpty ? (
        <EmptyView
          title="Unlock your credit"
          subtitle="Finish an episode and the related quiz will appear here."
          img={emptyQuizzes}
        />
      ) : (
        <EpisodeGrid
          isLoading={isLoading}
          episodes={episodes}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.MY_LUMIQ,
            section: EVENT_CONSTANTS.SECTION.QUIZZES,
          }}
        />
      )}
    </Box>
  );
};
